import React from 'react'

function Plus() {
	return (
		<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M6.90234 12.0049H18.9023" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
			<path d="M12.9023 18.0049V6.00488" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	)
}

export default Plus
